import COLORS from "../../config/colors";
import { useLocSettings } from "../../hooks/SettingsHooks";
import { useSpecsTranslation } from "../../hooks/TranslationHooks";
import Icon from "../Icon";

const IconMenuItem = ({ field, value }: { field: string; value: string }) => {
  const settings = useLocSettings();
  const ts = useSpecsTranslation();

  const icon = settings.specifications?.[field]?.icons?.[value];

  return (
    <div className={"icon-menu-item"}>
      {icon && (
        <span
          className={"icon"}
          style={{
            color: icon.color || COLORS.bjelin_grey
          }}
          dangerouslySetInnerHTML={{ __html: icon.svg }}
        />
      )}
      <span className="title">{ts(field, value)}</span>
      <Icon name="chevron-right" type="fal" className="more-icon" />
    </div>
  );
};

export default IconMenuItem;
